export enum EUserCardTab {
  About = 'about',
  Photos = 'photos',
}
